import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CallError, Media, WebrtcDeviceViewComponent } from 'libs/vaelsys-webrtc-lib';
import { map } from 'rxjs';
import { Camera } from 'src/app/models/Camera';

@Component({
  selector: 'app-vaelsys',
  templateUrl: './vaelsys.component.html',
  styleUrls: ['./vaelsys.component.scss'],
})
export class VaelsysComponent implements OnInit {

  @ViewChild(WebrtcDeviceViewComponent) webRtcView!: WebrtcDeviceViewComponent;
  @Input('visible') visible: boolean;
  @Input('camera') camera: Camera;
  @Input('user') user: string;
  @Input('origin') origin: string;
  @Output('onDebounce') onDebounce: EventEmitter<void> = new EventEmitter();

  deviceId: string;
  validationCode: string;
  loadCamera: boolean;

  constructor() { }

  ngOnInit() {}

  ngDoCheck() {
    if(this.origin === 'page' && !this.loadCamera){
      this.loadComponent();
    }
  }

  ngAfterViewInit(){
    if(this.origin === 'component' && !this.loadCamera){
      this.loadComponent();
    }
  }

  loadComponent(){
    if (this.camera != null && this.camera.camera_url != null) {
      this.loadCamera = true;
      this.loadDataCamera();
      this.onDebounce.emit();
    }
  }

  loadDataCamera() {
    //Obtener device id
    this.deviceId = this.camera.camera_url.substring(this.camera.camera_url.lastIndexOf('://') + 3, this.camera.camera_url.lastIndexOf('?'));

    //Obtener validation code
    this.validationCode = this.camera.camera_url.substring(this.camera.camera_url.lastIndexOf('key=') + 4, this.camera.camera_url.length);
  }

  async connect(): Promise<boolean> {
    return await this.webRtcView.select(this.camera.deal_id, this.camera.s_ins, this.camera.s_cam, this.deviceId, this.validationCode)
      .then(async (value) => {
        return value;
      }
      ).catch(error => {
        return false;
      });
  }

  async live(): Promise<boolean> {
    return await this.webRtcView.live(false)
      .then(
        (value) => {
          return value;
        }
      )
      .catch(
        async (err) => {
          return false;
        }
      );
  }

  async stop() : Promise<boolean> {
    return await this.webRtcView.stop()
    .then((value) => {
      return value;
    })
    .catch((err) => {
      return false;
    });
  }

  async handleToggleAudio(pressedListen: boolean): Promise<boolean> {
    return await this.webRtcView.setMuted(pressedListen)
      .then(
        (value) => {
          return value;
        })
      .catch(
        (error) => {
          return false;
        }
      );
  }

  async twoWayAudio(pressedTalk: boolean): Promise<boolean> {
    return await this.webRtcView.setAudioSending(!pressedTalk)
      .then(
        (value) => {
          return value;
        }
      )
      .catch(
        (error) => {
          return false;
        }
      );
  }

  async checkAutotracking(): Promise<boolean> {
    return await this.webRtcView.isAutoTrackingEnabled()
      .then((value) => {
        return value;
      })
      .catch((error) => {
        return null;
      }
      );
  }

  async toggleAutotracking(trackingMode: string): Promise<boolean> {
    return await this.webRtcView.setAutoTracking(trackingMode === 'ON' ? false : true)
      .then((value) => {
        return value;
      })
      .catch(async (error) => {
        return false;
      }
      );
  }

  async mediaLookup(dateSinceAux: string, dateUntilAux: string): Promise<Media[]> {
    return await this.webRtcView.mediaLookup(new Date(Date.parse(dateSinceAux)), new Date(Date.parse(dateUntilAux)))
      .then(async (results) => {
        return results;
      })
      .catch(async (error) => {
        return null;
      }
    )
  }

  async seek(startDate: Date, endDate?: Date): Promise<boolean>{
    return await this.webRtcView.seek(new Date(Date.parse(startDate.toISOString())), endDate != null ? new Date(Date.parse(endDate.toISOString())) : null)
      .then(async (value) => {
        return value;
      }).catch(error => {
        return false;
      });
  }

  lastError(): CallError {
    let error: CallError | undefined = this.webRtcView.lastError();
    return error;
  }

  isAudioSending(){
    return this.webRtcView.isAudioSending();
  }

  async setPaused(paused: boolean): Promise<boolean>{
    return await this.webRtcView.setPaused(paused)
      .then(async (value) => {
        return value;
      }).catch(error => {
        return false;
      });
  }

  async isPaused(): Promise<boolean>{
    return await this.webRtcView.isPaused()
      .then(async (value) => {
        return value;
      }).catch(error => {
        return false;
      });
  }
}
